import React from 'react'
import { Picker } from '@react-native-picker/picker'
import { ModalSelectorCustomProfile } from './ModalSelector'
import { Platform, StyleSheet } from 'react-native'
import Colors from '../../constants/Colors'
import { TypographyStyles } from '../../styles'

export function SelectList(props) {
  if (Platform.OS === 'web') {
    return (
      <Picker
        accessibilityLabel={props.accessibilityLabel}
        accessibilityHint={props.accessibilityHint}
        selectedValue={props.selectedValue}
        onValueChange={props.onValueChange}
        style={styles.picker}
        enabled={props.enabled}
      >
        {props.children}
      </Picker>
    )
  } else {
    return (
      <ModalSelectorCustomProfile
        data={props.list}
        keyExtractor={(data) => (props.specialID ? data.id?.toString() : data)}
        labelExtractor={(data) => (props.specialID ? data.name : data)}
        initValue={props.specialID ? props.initValue.name : props.initValue}
        onChange={props.onValueChange}
        disabled={props.enabled === false}
        style={styles.picker}
      />
    )
  }
}

const styles = StyleSheet.create({
  picker: {
    backgroundColor: Colors.white,
    marginLeft: Platform.OS === 'web' ? -5 : -9,
    ...TypographyStyles.text,
    borderColor: Colors.transparent,
    color: Colors.text,
  },
})
